//
//
//
//

export default {
  props: {
    gap: String
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/box/index.vue